export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const LICENCE_DETAILS = 'licence-details';

export const CANCEL_AIRCRAFTLICENCE_APPLICATION = [
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Licence Details',
        fieldList: [
            {
                id: 'licensee-nric',
                label: 'Licensee NRIC',
                type: 'text'
            },
            {
                id: 'registration-no-uen-other',
                label: 'Registration No Uen Other',
                type: 'text'
            },
            {
                id: 'licence-no',
                label: 'Licence No',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Cancellation Information',
        fieldList: [
            {
                id: 'effectiveDateOfCancellation',
                label: 'Effective Date Of Cancellation',
                type: 'text'
            },
            {
                id: 'cancellationReason',
                label: 'Cancellation Reason',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
